// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

#slidecaption {
    -webkit-animation-name: spinner; 
   -webkit-animation-timing-function: linear; 
   -webkit-animation-iteration-count: infinite; 
   -webkit-animation-duration: 2s; 
   animation-name: spinner; 
   animation-timing-function: linear; 
   animation-iteration-count: infinite; 
   animation-duration: 2s; 
   transform-style: preserve-3d;
}

 /* WebKit and Opera browsers */ /* all other browsers */ 
@keyframes spinner { 
   from { 
       transform: rotateY(0deg); 
   } 
   to 
   { 
       transform: rotateY(-360deg); 
   
   } 
}`, "",{"version":3,"sources":["webpack://./src/hoc/loader/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;IACI,+BAA+B;GAChC,yCAAyC;GACzC,2CAA2C;GAC3C,8BAA8B;GAC9B,uBAAuB;GACvB,iCAAiC;GACjC,mCAAmC;GACnC,sBAAsB;GAItB,4BAA4B;AAC/B;;CAEC,8BAA8B,EAQ7B,uBAAuB;AACzB;GACG;OAGI,wBAAwB;GAC5B;GACA;;OAII,2BAA2B;;GAE/B;AACH","sourcesContent":["/**\n * Copyright 2022 MobiledgeX, Inc\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n#slidecaption {\n    -webkit-animation-name: spinner; \n   -webkit-animation-timing-function: linear; \n   -webkit-animation-iteration-count: infinite; \n   -webkit-animation-duration: 2s; \n   animation-name: spinner; \n   animation-timing-function: linear; \n   animation-iteration-count: infinite; \n   animation-duration: 2s; \n   -webkit-transform-style: preserve-3d; \n   -moz-transform-style: preserve-3d; \n   -ms-transform-style: preserve-3d; \n   transform-style: preserve-3d;\n}\n\n /* WebKit and Opera browsers */ @-webkit-keyframes spinner { \n   from \n   { \n       -webkit-transform: rotateY(0deg); \n   } \n   to { \n       -webkit-transform: rotateY(-360deg); \n   } \n} /* all other browsers */ \n@keyframes spinner { \n   from { \n       -moz-transform: rotateY(0deg); \n       -ms-transform: rotateY(0deg); \n       transform: rotateY(0deg); \n   } \n   to \n   { \n       -moz-transform: rotateY(-360deg); \n       -ms-transform: rotateY(-360deg); \n       transform: rotateY(-360deg); \n   \n   } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
